module.exports = "/src/views/player/jobselector/assets/images/padlock-unlock.svg";